import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'radio-question',
  templateUrl: './radio-question.component.html',
})
export class RadioQuestionComponent {
  @Input() data: { title: string };
  @Input() valueSelected: any = '0';
  @Input() active = true;
  @Output() selectAnswer: EventEmitter<any> = new EventEmitter<any>();

  onAnswerSelected(value) {
    if (!this.active) {
      return;
    }
    this.selectAnswer.emit(value);
  }
}
